var map = {
	"./en/00.intro.md": 1048,
	"./en/01.psychometry.md": 1049,
	"./en/02.why_test.md": 1050,
	"./en/03.interpret.md": 1051,
	"./en/04.communicate.md": 1052,
	"./en/05.remember.md": 1053,
	"./en/06.job_analysis.md": 1054,
	"./nb/00.intro.md": 1055,
	"./nb/01.psykometri.md": 1056,
	"./nb/02.hvorfor_teste.md": 1057,
	"./nb/03.tolkning.md": 1058,
	"./nb/04.kommunisere.md": 1059,
	"./nb/05.husk.md": 1060,
	"./nb/06.jobbanalyse.md": 1061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1047;